import {View} from '@fantasmagames/slot/src/common/view/View';
import {GameReelConstants} from 'src/reels/GameReelConstants';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export class FreeSpinsTriggerView extends View {
	public static readonly ANIMATION_FINISHED_AT: string = 'ANIMATION_FINISHED_AT';

	public playTriggerAnimationAt(symbolPos: Position): void {
		const startPos: Position = GameReelConstants.getGameSymbolCenterPosition(symbolPos);

		const triggerAnim: SpineAnimation =
			this.spineUtils.startSpineAnimationCreation('BONUS_SCATTER.json', 'TRIGGER_BONUS', false)
				.container(this.container)
				.onComplete(() => {
					this.playExitAnimationAt(startPos, symbolPos);
					this.spineUtils.stopAndDestroyAnimation(triggerAnim);
				})
				.position(startPos)
				.createAndStart();
	}

	protected playExitAnimationAt(startPos: Position, symbolPos: Position): void {
		const exitrAnim: SpineAnimation =
			this.spineUtils.startSpineAnimationCreation('BONUS_SCATTER.json', 'EXIT', false)
				.container(this.container)
				.onComplete(() => {
					this.emit(FreeSpinsTriggerView.ANIMATION_FINISHED_AT, symbolPos);
					this.spineUtils.stopAndDestroyAnimation(exitrAnim);
				})
				.position(startPos)
				.createAndStart();
	}
}


// WEBPACK FOOTER //
// ./src/freespinstrigger/FreeSpinsTriggerView.ts